import { CalendarMode, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";

export const checkIsLastLevel = (calendarMode: CalendarMode, { type }: Row) => {
  if (calendarMode === CalendarMode.Workforce) {
    return type !== RowType.Profile;
  } else {
    return type === RowType.Profile;
  }
};
